// Generated by CoffeeScript 2.7.0
export var DetailGroupMixin = {
  name: 'DetailGroup',
  props: ['detail', 'group', 'index', 'isAdmin', 'response', 'previousFieldVm', 'disappearedFieldIds'],
  data: function() {
    return {
      groupedFieldList: null,
      valid: true
    };
  },
  mounted: function() {
    this.$emit('groupAdded', this);
    return this.groupedFieldList = this.$refs.groupedFieldList;
  },
  computed: {
    sortedFields: function() {
      return _.chain(this.detail.children).filter((field) => {
        if (this.isAdmin) {
          return true;
        } else {
          return field.visibility !== 'private_visibility';
        }
      }).sortBy('position').value();
    },
    valueForCalculation: function() {
      if (this.groupedFieldList) {
        return _.reduce(this.groupedFieldList.fieldChildren, function(acc, fieldView) {
          var value;
          value = fieldView.valueForCalculation;
          if (value) {
            acc[fieldView.field.identity_key] = value;
          }
          return acc;
        }, {});
      } else {
        return {};
      }
    }
  },
  methods: {
    fieldValueChange: function(fieldView) {
      this.$emit('fieldValueChange', fieldView);
      if (fieldView.valuePresent && fieldView.field.validations.indexOf('presence') === -1) {
        return;
      }
      return this.resetGroupValidIfNeed();
    },
    resetGroupValidIfNeed: function() {
      var ref;
      if (this.valid) {
        return _.each((ref = this.groupedFieldList) != null ? ref.fieldChildren : void 0, function(fieldView) {
          return fieldView._resetValid();
        });
      }
    },
    destroy: function() {
      var before_destroy_confirm;
      before_destroy_confirm = this._ensureDestroyConfirm();
      return before_destroy_confirm.$on('ensureClicked', () => {
        return this.destroyGroup();
      });
    },
    destroyGroup: function() {
      this.$emit('groupWillDestroy', _.filter(this.getEntries(), function(entry) {
        if (entry.id) {
          entry._destroy = true;
        }
        return entry.id;
      }));
      return this.$emit('childWillRemoved', this);
    },
    isEmptyGroup: function() {
      var ref;
      return _.every((ref = this.groupedFieldList) != null ? ref.fieldChildren : void 0, function(fieldView) {
        return !fieldView.valuePresent;
      });
    },
    forceValidate: function() {
      var ref;
      return (ref = this.groupedFieldList) != null ? ref.getEntries() : void 0;
    },
    getEntries: function(validate_ignore = false) {
      var entries, ref;
      entries = (ref = this.groupedFieldList) != null ? ref.getEntries(validate_ignore) : void 0;
      _.each(entries, (entry) => {
        entry.group_id = this.group.id;
        return entry.detail_id = this.detail.id;
      });
      // 如果group是合法的，应当reset掉之前报的错误
      this.resetGroupValidIfNeed();
      return entries;
    },
    needReset: function() {
      var ref;
      return _.some((ref = this.groupedFieldList) != null ? ref.fieldChildren : void 0, function(fieldView) {
        return fieldView.field.value_cache && fieldView.valuePresent;
      });
    },
    getResetEntries: function() {
      var ref;
      return (ref = this.groupedFieldList) != null ? ref.getResetEntries() : void 0;
    },
    onValidChangedFunc: function(val) {
      return this.valid = val;
    }
  }
};

export var DetailMixin = {
  data: function() {
    return {
      groupViewChilden: []
    };
  },
  computed: {
    groupsValid: function() {
      // 该属性用来记录下面的所有的group是否合法
      // valid用来记录detail字段本身是否合法(如果必填，则只需要判断是否存在group)
      // 最终明细字段是否合法，需要groupsValid和valid共同决定
      return _.every(this.groupViewChilden, function(groupView) {
        return groupView.valid;
      });
    },
    valid: function() {
      return !this.errors.length && this.groupsValid;
    },
    valuePresent: function() {
      return _.some(this.groupViewChilden, function(groupView) {
        return !groupView.isEmptyGroup();
      });
    },
    valueForCalculation: function() {
      var value;
      if (_.isEmpty(this.groupViewChilden)) {
        return;
      }
      value = _.reduce(this.groupViewChilden, function(acc, groupVm) {
        value = groupVm.valueForCalculation;
        if (value !== {}) {
          acc[groupVm.group.id] = value;
        }
        return acc;
      }, {});
      return {
        type: 'Detail',
        value: value
      };
    }
  },
  created: function() {
    return this.$watch('response', function() {
      this._clearDestroyedEntries();
      // entries更新之后，detail-field的value没有改变，detail-group的entries保存在group上，
      // 所以group的entries没有更新， 所以需要重新parseEntriesToValue
      // 执行函数后data里面的groupViewChildren 会新增一个，
      // 导致最后getEntries的时候会提取到一个有id的和一个没有id的entry，
      // 所以要reset把groupViewChildren
      // FIXME: 优化此处
      return this._resetGroupView(this.entries);
    }, {
      sync: true
    });
  },
  methods: {
    addGroupViewFunc: function(groupView) {
      this.groupViewChilden = this.groupViewChilden.concat(groupView);
      return this.$emit('valueChange', this);
    },
    addGroup: function() {
      this._addGroup();
      return this.$nextTick(function() {
        return this.validate();
      });
    },
    groupWillDestroy: function(destroyedEntries) {
      return this._destroyedEntries = (this._destroyedEntries || []).concat(destroyedEntries);
    },
    removeChild: function(childView) {
      this.valueChange(_.without(this.value, childView.group));
      this.groupViewChilden = _.without(this.groupViewChilden, childView);
      if (_.isEmpty(this.value)) {
        return this._addGroup();
      } else {
        return this.$emit('valueChange', this);
      }
    },
    fieldValueChange: function(field) {
      this.validate();
      return this.$emit('valueChange', field);
    },
    reset: function() {
      var _groups;
      this._resetValid();
      _groups = [];
      _.each(this.groupViewChilden, function(child) {
        if (child.needReset()) {
          return _groups.push({
            id: _.now(),
            entries: child.getResetEntries()
          });
        }
      });
      this.value = _groups;
      if (_.isEmpty(this.value)) {
        return this._addGroup();
      }
    },
    _addGroup: function() {
      return this.value.push({
        id: _.now(),
        entries: []
      });
    },
    _parseValueToEntries: function(validate_ignore = false) {
      var restEntries;
      restEntries = _.flatten(this.groupViewChilden.map(function(detail_group) {
        return detail_group.getEntries(validate_ignore);
      }));
      return restEntries.concat(this._destroyedEntries || []);
    },
    _clearDestroyedEntries: function() {
      return this._destroyedEntries = [];
    },
    _resetGroupView: function(entries) {
      this.value = [];
      this.groupViewChilden = [];
      return this._parseEntriesToValue(entries);
    },
    _parseEntriesToValue: function(entries) {
      // as detail groups
      this.value = _.chain(entries).groupBy('group_id').map(function(entries, groupId) {
        return {
          id: groupId,
          entries: entries
        };
      }).sortBy('id').value();
      if (_.isEmpty(this.value)) {
        return this._addGroup();
      }
    }
  }
};

export default DetailMixin;
